module.exports = __webpack_public_path__ + "static/img/okamoto_01.a0d1247.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/okamoto_01.png
// module id = SXUj
// module chunks = 0